module.exports = __webpack_public_path__ + "static/Tetra-f9d09b7adf474934d57e2f0360cf08ac.otf";